import React from 'react';
type Props = {
  kicker: string;
  title: string;
  intro?: string[];
  tone?: 'dark' | 'light';
};
export function SectionHeader({
  kicker,
  title,
  intro,
  tone = 'light'
}: Props) {
  const dark = tone === 'dark';
  return <div className="mx-auto max-w-3xl text-center" data-id="element-395" data-mp="22j4zuox0ffdc">
      <p className={`font-display text-sm font-extrabold uppercase tracking-wide md:text-base ${dark ? 'text-cyan' : 'text-blue'}`} data-id="element-396" data-mp="27gnemvxpkot9">
        {kicker}
      </p>
      <h2 className={`mt-3 text-balance font-display text-[32px] font-black leading-[1.05] tracking-tight md:text-5xl ${dark ? 'text-white' : 'text-heading'}`} data-id="element-397" data-mp="2v799flipcclb">
        {title}
      </h2>
      {intro && <div className={`mt-5 space-y-3 text-[17px] leading-relaxed md:text-lg ${dark ? 'text-white/75' : 'text-body'}`} data-id="element-398" data-mp="2q74sjudvtfuk">
          {intro.map(p => <p key={p} data-id="element-399" data-mp="19rtqeo18oqib">{p}</p>)}
        </div>}
    </div>;
}